import React, { useState } from 'react'
import { Carousel, InputGroup, Button, FormControl } from 'react-bootstrap';
import Navbar from './Navbar';
import { bestdeal, mangeos, fruits, VEGETABLES, herbs, dryfruits, staples } from "./data"
import Row from './Row';
import "./css/App.css"
import Footer from './Footer';
import {Link} from "react-router-dom"
import Cart from './Cart';
import { compose, withProps } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from "react-google-maps";

export const Googlemap = compose(
  withProps({
    /**
     * Note: create and replace your own key in the Google console.
     * https://console.developers.google.com/apis/dashboard
     * The key "AIzaSyBkNaAGLEVq0YLQMi-PYEMabFeREadYe1Q" can be ONLY used in this sandbox (no forked).
     */
    googleMapURL:
      "https://maps.googleapis.com/maps/api/js?key=da1cb82f3290c4c6fd7ff911a2a3f14a&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `400px` }} />,
    mapElement: <div style={{ height: `100%` }} />
  }),
  withScriptjs,
  withGoogleMap
)(props => (
  <GoogleMap defaultZoom={8} defaultCenter={{ lat: -34.397, lng: 150.644 }}>
    {props.isMarkerShown && (
      <Marker position={{ lat: -34.397, lng: 150.644 }} />
    )}
  </GoogleMap>
))


function Home() {
 const [carts,setCarts] = useState(false)

  console.log(carts)

  return (
    <div className='home-container'>

      <Navbar setCarts={setCarts}/>
      <div className={carts ? "show" : "hide"}>
      <Cart setCarts={setCarts} carts={carts}/>
      </div>

      {/* <div className='sliding'>
        <Carousel>
          <Carousel.Item interval={1000}>
            <img
              className="d-block w-100"
              src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/fff82bab-1f8a-4e95-a782-07a507e80330/demybhn-29a5845e-7579-4579-8041-2026c7a9979d.jpg/v1/fill/w_753,h_1061,q_70,strp/chicken_tikka_by_srinumdh_demybhn-pre.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTQzNiIsInBhdGgiOiJcL2ZcL2ZmZjgyYmFiLTFmOGEtNGU5NS1hNzgyLTA3YTUwN2U4MDMzMFwvZGVteWJobi0yOWE1ODQ1ZS03NTc5LTQ1NzktODA0MS0yMDI2YzdhOTk3OWQuanBnIiwid2lkdGgiOiI8PTEwMjAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.ZM2iFkcu2xLIjEK_EYLKbsXVwqLiEIWHzPpOhRepCPA"
              alt="First slide"
            />
          </Carousel.Item>
          <Carousel.Item interval={500}>
            <img
              className="d-block w-100"
              src="https://img.freepik.com/free-psd/food-menu-restaurant-social-media-banner-template_106176-1335.jpg?w=2000"
              alt="Second slide"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src="https://s3.ap-south-1.amazonaws.com/fraazo-prod/web_ban/2340.png?1651429269"
              alt="Third slide"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src="https://img.freepik.com/free-psd/food-menu-restaurant-social-media-banner-template_106176-1335.jpg?w=2000"
              alt="Third slide"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src="https://cdn.dribbble.com/users/5254768/screenshots/14688619/presentasi_drible1.png"
              alt="Third slide"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src="https://s3.ap-south-1.amazonaws.com/fraazo-prod/web_ban/2395.png?1651429486"
              alt="Third slide"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src="https://cdn.dribbble.com/users/5254768/screenshots/14688619/presentasi_drible1.png"
              alt="Third slide"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src="https://cdn.dribbble.com/users/5254768/screenshots/14688619/presentasi_drible1.png"
              alt="Third slide"
            />
          </Carousel.Item>
        </Carousel>
        <div className='static-img'>
          <img src="https://cdn.dribbble.com/users/5254768/screenshots/14688619/presentasi_drible1.png" alt="" />
          <img src="https://fraazo.com/static/Web3-9f5a46f22ff99bcfe079257218356413.png" alt="" />
          <img src="https://fraazo.com/static/Web2-9a152d86240414d76ce205c491e47c4e.png" alt="" />
        </div>
      </div> */}

      {/* <Link to="/products#pagetop"> */}
      <div className='fic-images'>
        <img src="https://i.ibb.co/9tQhK64/Combo.png" alt="" />
        <img src="https://c.ndtvimg.com/2022-06/gp4k2jro_burgers_625x300_20_June_22.jpg?im=FeatureCrop,algorithm=dnn,width=620,height=350?im=FaceCrop,algorithm=dnn,width=1200,height=886" alt="" />
        <img src="https://i.ibb.co/N7Zq3Hx/Fried-Chicken.png" alt="" />
        <img src="https://kauveryhospital.com/blog/wp-content/uploads/2021/04/pizza-5179939_960_720.jpg" alt="" />
        <img src="https://static.toiimg.com/thumb/87672662.cms?width=680&height=512&imgsize=111910" alt="" />
        <img src="https://content.jdmagicbox.com/comp/mumbai/p9/022pxx22.xx22.190104174006.j4p9/catalogue/vijay-sandwich-borivali-west-mumbai-sandwich-stalls-ccdrm9kh91.jpg" alt="" />
      </div>
        {/* </Link> */}
      <Row title={bestdeal} name="BESTDEALS" carts={carts}/>





      <Row title={mangeos} name="Burgers" />
      <Row title={fruits} name="Fried Chicken" />
      <Row title={VEGETABLES} name="Fries" />
      <Row title={herbs} name="Pizzas" />
      <Row title={dryfruits} name="Momos" />
      <Row title={staples} name="Sandwitches" />


      <div className='download-app'>
        <div className='download-img'>
          <img src="https://i.ibb.co/7jf58Kn/The-Crisp-Bite-2.png" alt="ioje" />
        </div>
        <div className='download-form'>
          <h2>Download The App</h2>
          <h5>Enter your phone number to recieve a text with a link to download the app</h5>
          <div className='bbb'>

            <InputGroup className="mb-3">
              <Button variant="outline-secondary" id="button-addon1">
                + 91
              </Button>
              <FormControl
                aria-label="Example text with button addon"
                aria-describedby="basic-addon1"
                placeholder='Enter Mobile Number'
              />
            </InputGroup>
          </div>
          <button id='button'>SUBMIT</button>
          <div className='available'>
            Available on
            <img src="https://www.edsys.in/wp-content/uploads/Play-Store-Logo-2.png" alt="" />
            <img src="https://miro.medium.com/max/600/1*xqT83bMEz92IBYxS9UQNow.png" alt="" />
          </div>
        </div>

      </div>

    <Footer/>
<Googlemap/>
    </div>
  )
}

export default Home


